import React from 'react';

const ErrorMessage = () => {
    return (
        <h1 style={{color: 'red'}}>
            Error: page not found
        </h1>
    );
};

export default ErrorMessage;